import { Package, UserCog, ShieldCheck } from "lucide-react";
import { OrdersPage } from "../features/orders/OrdersPage";
import { BillingPanel } from "../features/billing/BillingPanel";
import { AllegroProductCollection } from "../features/offers/AllegroProductCollection";
import { ProductCollection } from "../features/products/ProductCollection";
import { OrdersDev } from "../features/ordersDev/OrdersDev";
import { ProfileSettings } from "../features/settings/ProfileSettings";
import { AccountSettings } from "../features/settings/AccountSettings";
import { OrdersIcon } from "../components/icons/OrdersIcon";
import {
  BillingNavIcon,
  DashboardNavIcon,
  OffersNavIcon,
  OrdersDevNavIcon,
  OrdersNavIcon,
  ReportsNavIcon,
} from "../components/icons/NavIcons";
import { DashboardPage } from "../pages/DashboardPage";
import { ReportsPage } from "../pages/ReportsPage";

export const LEGACY_SECTION_ROUTE_MAP = {
  dashboard: "/dashboard",
  reports: "/reports",
  orders: "/orders",
  products: "/products",
  offers: "/offers",
  purchase: "/products",
  billing: "/billing",
  ordersDev: "/orders-dev",
  settings: "/settings/profile",
  profile: "/settings/profile",
  account: "/settings/account",
};

export const ROUTE_REDIRECTS = {
  "/": "/dashboard",
  "/settings": "/settings/profile",
  "/purchase-costs": "/products",
};

export const APP_ROUTE_DEFINITIONS = [
  {
    path: "/dashboard",
    Component: DashboardPage,
    layout: {
      wrapContent: false,
      showHeader: false,
    },
    nav: {
      label: "Dashboard",
      icon: DashboardNavIcon,
      exact: true,
      useActiveState: true,
    },
  },
  {
    path: "/reports",
    Component: ReportsPage,
    layout: {
      wrapContent: false,
      showHeader: false,
    },
    nav: {
      label: "Reports",
      icon: ReportsNavIcon,
      exact: true,
      useActiveState: true,
    },
  },
  {
    path: "/orders",
    Component: OrdersPage,
    layout: {
      accent: "Orders",
      title: "Orders",
      subtitle: "Monitor the flow of recent Allegro orders and profitability at a glance.",
      icon: OrdersIcon,
      wrapContent: false,
      showHeader: false,
    },
    nav: {
      label: "Orders",
      icon: OrdersNavIcon,
      exact: true,
      useActiveState: true,
    },
  },
  {
    path: "/offers",
    Component: AllegroProductCollection,
    layout: {
      wrapContent: false,
      showHeader: false,
      contentClassName: "max-w-8xl",
    },
    nav: {
      label: "Offers",
      icon: OffersNavIcon,
      useActiveState: true,
    },
  },
  {
    path: "/orders-dev",
    Component: OrdersDev,
    layout: {
      wrapContent: true,
      showHeader: false,
      contentClassName: "max-w-none",
      isFullWidth: true,
      outerSpacingClassName: "px-8 pt-2 pb-2 md:pt-2 md:pb-2 md:pr-2",
      useCustomOuterSpacing: false,
    },
    nav: {
      label: "Orders Dev",
      icon: OrdersDevNavIcon,
      useActiveState: true,
    },
  },
  {
    path: "/products",
    Component: ProductCollection,
    layout: {
      wrapContent: true,
      showHeader: false,
    },
    nav: {
      label: "Products",
      icon: Package,
    },
  },
  {
    path: "/billing",
    Component: BillingPanel,
    layout: {
      wrapContent: true,
      showHeader: false,
    },
    nav: {
      label: "Billing",
      icon: BillingNavIcon,
      useActiveState: true,
    },
  },
  {
    path: "/settings/profile",
    Component: ProfileSettings,
    layout: {
      wrapContent: true,
      showHeader: false,
    },
    nav: {
      label: "Profile Settings",
      icon: UserCog,
      exact: true,
      useActiveState: true,
    },
  },
  {
    path: "/settings/account",
    Component: AccountSettings,
    layout: {
      wrapContent: true,
      showHeader: false,
    },
    nav: {
      label: "Account Settings",
      icon: ShieldCheck,
      exact: true,
      useActiveState: true,
    },
  },
];

export const SIDEBAR_NAV_ITEMS = APP_ROUTE_DEFINITIONS.filter(({ nav }) => Boolean(nav)).map(
  ({ nav, path }) => ({ ...nav, to: path })
);
